import * as React from 'react';
import { ActorApiStringDisplay } from '../../../../../actor/components/display/string';
import { useLocalizedSanityNewsListWithSearchTermAndLimitsByPrimaryDimensionSlug } from '../../../../../sanity';

export const ArticleTitle = () => {
  const {
    isLoading,
    data,
    error,
  } = useLocalizedSanityNewsListWithSearchTermAndLimitsByPrimaryDimensionSlug();
  const {
    title,
  } = data ?? {};
  return (
    <ActorApiStringDisplay
      data={title}
      isLoading={isLoading}
      error={error}
      loadingValue="--- --------- --- --------- ------------ ------ --- --------- --- ---------------"
    />
  );
};
